import {Injectable} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {Observable} from "rxjs";
import {IDisplayElement} from "@ispm/test/interfaces/test-header-elements.interface";
import {IgenomicsState} from "@ispm/core/interfaces/genomics-state.interface";
import {filter} from "rxjs/operators";
import {get, has} from 'lodash';

@Injectable()
export class TestMetaDataStoreHandler {

  private defaultHeaderFields: string;
  private testMetaDataStore$: any;

  constructor(private store$: Store<IgenomicsState>) {
    this.testMetaDataStore$ = store$.select('tests', 'meta', 'config');

    this.defaultHeaderFields = 'defaultView';
    this.store$.pipe(select('navigation')).pipe(
      filter(orgWebConfig => !!orgWebConfig))
      .subscribe((orgWebConfig) => {
        this.defaultHeaderFields = get(orgWebConfig, 'navigation.patientHeaderView', 'defaultView');
      });
  }

  public getDisplayConfig(): Observable<Array<IDisplayElement> | null> {
    return this.testMetaDataStore$.select('displayElements')
      .take(1)
      .map(data => {
        if (!data.has(this.defaultHeaderFields)) {
          return null;
        } else {
          return data.get(this.defaultHeaderFields);
        }
      });
  }

  public getValueByKey(data, key: string, defaultValue: string): string| undefined {
     return get(data, key, defaultValue);
  }

  public hasKey(data, key: string): boolean {
    return has(data, key);
  }
}
